import { memo, useMemo } from "react";

import type { HotelApplicationDataQueryQuery, HotelTopQuery } from "@/lib/gql/__generated__/graphql";

import { useHotelFullUrls } from "@/components/features-new/hotel-top/components/_shared/use-hotel-full-urls";

import { LinkButton } from "./components/link-button";
import { URL_TYPES } from "./constants";

type Props = {
	hotelUrls: HotelTopQuery["hotelUrls"];

	inUseBasic: HotelApplicationDataQueryQuery["hotelApplicationStatus"]["inUseBasic"];
	isHotelPolicyRegistered: HotelApplicationDataQueryQuery["hotelApplicationStatus"]["isHotelPolicyRegistered"];
};

export const HotelUrls = memo(({ hotelUrls, inUseBasic, isHotelPolicyRegistered }: Props) => {
	const { fullUrlPlain, fullUrlMagazine, fullUrlSnack } = useHotelFullUrls(hotelUrls);

	const canShowPlain = useMemo(() => inUseBasic && !!fullUrlPlain, [inUseBasic, fullUrlPlain]);
	const canShowMagazine = useMemo(
		() => isHotelPolicyRegistered && !!fullUrlMagazine,
		[isHotelPolicyRegistered, fullUrlMagazine],
	);
	const canShowSnack = useMemo(() => inUseBasic && !!fullUrlSnack, [inUseBasic, fullUrlSnack]);

	return (
		<>
			{canShowPlain && (
				<div className="space-y-2">
					<p>{URL_TYPES.PLAIN.title}</p>
					<LinkButton url={fullUrlPlain} />
				</div>
			)}

			{canShowMagazine && (
				<div className="space-y-2">
					<p>{URL_TYPES.MAGAZINE.title}</p>
					<LinkButton url={fullUrlMagazine} />
				</div>
			)}

			{canShowSnack && (
				<div className="space-y-2">
					<p>{URL_TYPES.SNACK.title}</p>
					<LinkButton url={fullUrlSnack} />
				</div>
			)}
		</>
	);
});

HotelUrls.displayName = "HotelUrls";
